module.exports = __webpack_public_path__ + "img/lock.d98b23d3.svg";